import { render } from "./user-menu.vue?vue&type=template&id=66604588"
import script from "./user-menu.vue?vue&type=script&lang=js"
export * from "./user-menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__